var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nrk"},[_c('Nav')],1),_c('router-view'),_c('bottom-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }